import { Search, Calculator, FileText, Building2, MapPin, Database, TrendingUp, LucideIcon } from "lucide-react";

export interface Ferramenta {
  id: number;
  title: string;
  description: string;
  icon: LucideIcon;
  status: "Disponível" | "Em breve";
  externalUrl?: string;
  isIndicadores?: boolean;
}

export const FERRAMENTAS: Ferramenta[] = [
  {
    id: 2,
    title: "Calculadora de Indicadores",
    description: "Calcule correção de valores por indicadores como IGP-M, IPCA, IVAR e INCC.",
    icon: Calculator,
    status: "Disponível",
    isIndicadores: true
  },
  {
    id: 7,
    title: "Simulador Financiamento Imobiliário",
    description: "Simule financiamentos imobiliários e calcule parcelas, juros e amortização.",
    icon: TrendingUp,
    status: "Disponível",
    externalUrl: "https://www.mobills.com.br/calculadoras/simulador-de-financiamento-imobiliario/"
  },
  {
    id: 1,
    title: "Consulta de Imóveis",
    description: "Pesquise informações cadastrais de imóveis em todo o território nacional.",
    icon: Search,
    status: "Em breve"
  },
  {
    id: 3,
    title: "Gerador de Documentos",
    description: "Gere documentos padronizados conforme as exigências da nova lei.",
    icon: FileText,
    status: "Em breve"
  },
  {
    id: 4,
    title: "Mapa de Cartórios",
    description: "Encontre cartórios de registro de imóveis em sua região.",
    icon: MapPin,
    status: "Em breve"
  },
  {
    id: 5,
    title: "Validador de Matrículas",
    description: "Valide a autenticidade de matrículas imobiliárias.",
    icon: Building2,
    status: "Em breve"
  },
  {
    id: 6,
    title: "API de Integração",
    description: "Integre seus sistemas com o Cadastro Imobiliário Brasileiro.",
    icon: Database,
    status: "Em breve"
  }
];
